import { InjectionToken } from '@angular/core';
import { IBehaviorTrackingProvider } from 'app/behavior-tracking/interfaces/behavior-tracking-provider.interface';

export const BEHAVIOR_TRACKING_PROVIDERS = new InjectionToken<IBehaviorTrackingProvider[]>('BEHAVIOR_TRACKING_PROVIDERS');
